@if (funding) {
    <modal [title]="getModalTitle()">
        <div class="has-text-left-desktop">
            <img class="" [src]="getSvg()" width="100" [alt]="getAltText()" />
        </div>
        <div class="box is-shadowless has-text-left">
            <div class="box-content has-background-grey-fade">
                <p class="text is-level-1 has-text-weight-bold">Après le premier versement :</p>
                <div class="rows has-gap-1">
                    @for (line of fundingLines; track line) {
                        <div class="row">
                            <checkout-funding-infos-phone-line
                                lineTitle="{{ line.lineTitle }}"
                                [value]="line.value"
                                [isBold]="line.isBold"
                            />
                        </div>
                    }
                </div>
            </div>
        </div>

        <p class="text is-level-1 has-text-weight-semibold has-text-left">
            Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
        </p>
        <p class="text is-level-2 has-text-left">
            Les informations affichées tiennent compte de l'ensemble de votre panier (terminal, accessoires, frais de
            livraison, etc...)
        </p>
    </modal>
}
